import { render, staticRenderFns } from "./PromotionalImage.vue?vue&type=template&id=1110dd08&scoped=true"
import script from "./PromotionalImage.vue?vue&type=script&lang=js"
export * from "./PromotionalImage.vue?vue&type=script&lang=js"
import style0 from "./PromotionalImage.vue?vue&type=style&index=0&id=1110dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110dd08",
  null
  
)

export default component.exports